<template>
  <div class="title_recommend">
    <slot name="left"></slot>
    <div style="display: flex; align-items: center">
      <el-tooltip
        class="item"
        effect="dark"
        content="地方、行业协会，央企总部"
        placement="bottom"
      >
        <p
          style="margin-right: 20px; color: #3c66ae; cursor: pointer;font-size:18px;font-weight: 600;"
          @click="openOutLink"
        >
          推荐单位登录
        </p>
      </el-tooltip>

      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    openOutLink() {
      window.open("http://203.0.105.80:81/login");
    },
  },
};
</script>
<style scoped>
.title_recommend {
  width: 95%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  margin-left: 20px;
  justify-content: space-between;
  border-bottom: 1px solid #bbb;
  margin-bottom: 20px;
}
</style>
